<template>
<v-container>
    <Navbar/>
    <v-row>
        <v-col md="12">
            <v-toolbar
                flat
                color="pink"
                dark
                >
                <center>เติมเงินโทรศัพท์</center>
            </v-toolbar>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="12">
            <form>
                <v-select v-bind:items='items' 
                label='เลือกเครือข่าย'
                v-model="topupData.operator"
                dense></v-select>
                
            </form>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="12">
                  <v-textarea
                    v-model="topupData.phoneNo"
                    label="เบอร์โทรศัพท์ใส่เบอร์ละบรรทัด"
                    full-width
                    single-line
                    outlined
                ></v-textarea>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="12">
                <v-select v-bind:items='amountItems'
                label='เติมเงิน'
                v-model="topupData.topupAmount"
                dense></v-select>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="12">
            <v-btn tile color="indigo" @click="setTopupdata" dark>เติมเงิน</v-btn>
            <v-btn tile color="pink" dark>ยกเลิก</v-btn>
            <!-- นี่คือคอมเมนต์ใน HTML <v-btn tile color="indigo" @click="reloadPage" dark>refresh</v-btn> -->
        </v-col>
    </v-row>
    <v-row>
        <v-col md="12">
            <Topuphist/>
        </v-col>
    </v-row>
    <v-dialog
      v-model="loader1"
      hide-overlay
      persistent
      width="300"        
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          กรุณารอสักครู่
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import Navbar from '../components/Navbar';
import Topuphist from '../components/Topuphist';
import axios from 'axios'
export default {
    name: 'Topuppage',
    components: {
        Navbar,Topuphist
    },
    data: () => ({
        items:[
            'TRMV',
            '12CALL',
            'HAPPY',
            'i-mobile 3GX',
            'my by CAT',
            'เพนกวิน',
            'TOT3G',
        ],
        amountItems:[
            '5',
            '10',
            '20',
            '30',
            '40',
            '50',
            '100'
        ],
        topupData:{
            operator:'',
            phoneNo:'',
            topupAmount:'',
        },
        loader1:false
    }),
    methods:{
        setTopupdata:function(){
            var errorMsg="";
            console.log("เครือข่าย : "+this.topupData.operator);
            console.log("เบอร์โทรศัพท์ : "+this.topupData.phoneNo);
            if(this.topupData.operator.length === 0){
                errorMsg = errorMsg.concat("กรุณาเลือกเครือข่าย\n")
            }
            if(this.topupData.phoneNo.length === 0){
                errorMsg = errorMsg.concat("กรุณากรอกหมายเลขโทรศัพท์\n")
            }
            if(this.topupData.topupAmount.length === 0){
                errorMsg = errorMsg.concat("กรุณาเลือกจำนวนเงินที่ต้องการเติม\n")
            }
            if(this.topupData.operator.length !== 0 && this.topupData.phoneNo.length !== 0 && this.topupData.topupAmount.length !== 0 && this.topupData.topupAmount.length !== 0){
                console.log("ok! เติมเงินได้");
                this.topUp()
            }
        if(errorMsg.length > 0){
            alert(errorMsg);
        }

    },

        topUp : function(){
            var phoneNoArray = this.topupData.phoneNo.split('\n');
            //const today = new Date();
            //const destRef = "mts"+phone+today.getHours()+today.getMinutes()+today.getSeconds();
            this.loader1=true;
            axios
            .post('https://topup.gpsthaistar.com/api/indexPhp.php',{
                request:6,
                pay_amount:this.topupData.topupAmount,
                pay_company:this.topupData.operator,
                phone_no:phoneNoArray
            })
            .then((result)=>{
                console.log(result.data);
                setTimeout(() => (this.loader1 = false), 1000)
                location.reload();
            })
            .catch(err=>(console.log(err)))
            setTimeout(() => (this.loader1 = false), 1000)
             console.log("failed2");
             location.reload();
        },
        
        updateTransaction : function(phone,destRef){
            axios
                .post('https://topup.gpsthaistar.com/api/indexPhp.php',{
                    request:1,
                    phone_no:phone,
                    phone_operator:this.topupData.operator,
                    trans_amount:this.topupData.topupAmount,
                    trans_status:"",
                    trans_ref:destRef,
                    trans_bill:""
                })
                .then((response)=>{
                    console.log(response.data);
                    this.location.reload();
                    this.$router.go()
                })
                .catch(err=>(console.log(err)))            
        },
        reloadPage:function(){
           console.log("Refresh");
           this.loader1=true;
           setTimeout(() => (this.loader1 = false), 1000)
           location.reload();
        }
        
    }

}
</script>

